import { Grid } from '@mui/material';
import { LuClock } from 'react-icons/lu';
import { ControlledTextInput, WsColors } from 'wisestep-base';

import WsAccordion from '../../../components/filters/components/WsAccordion';

const ExperienceRangeFilter = () => {
  return (
    <WsAccordion
      title="Total Experience (years)"
      startIcon={<LuClock color={WsColors.TertiaryShades800} />}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <ControlledTextInput
            name="totalExperience.min"
            fullWidth
            id="total-experience-min"
            placeholder="Min"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={6}>
          <ControlledTextInput
            name="totalExperience.max"
            fullWidth
            id="total-experience-max"
            placeholder="Max"
            variant="outlined"
            size="small"
          />
        </Grid>
      </Grid>
    </WsAccordion>
  );
};
export default ExperienceRangeFilter;
